import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { useAuthModal } from "../../../providers/AuthModalProvid";
import { useFreeTokensModal } from "../../../providers/FreeTokensModalProvider";
import { useSubscriptionsModal } from "../../../providers/SubscriptionsModalProvider";
import { colors } from "../../../design/tokens";

interface WelcomeGuestMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export function WelcomeGuestMenu({ isOpen, onClose }: WelcomeGuestMenuProps) {
  const navigate = useNavigate();
  const { show: showAuthModal } = useAuthModal();
  const { show: showFreeTokensModal } = useFreeTokensModal();
  const { open: openSubscriptionsModal } = useSubscriptionsModal();

  if (!isOpen) return null;

  const handleDiscoverApps = () => {
    onClose();
    navigate("/app-store-rankings");
  };

  const handlePricing = () => {
    onClose();
    openSubscriptionsModal();
  };

  const handleFreeTokens = () => {
    onClose();
    showFreeTokensModal();
  };

  const handleFaq = () => {
    onClose();
    navigate("/faq");
  };

  const handleBlog = () => {
    onClose();
    navigate("/blog");
  };

  const handleSignIn = async () => {
    onClose();
    await showAuthModal();
  };

  return createPortal(
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[100]"
        onClick={onClose}
      />

      {/* Menu - positioned to the right */}
      <div
        className={`fixed top-16 right-4 z-[110] w-[200px] ${colors.surface.secondary} rounded-lg shadow-lg border border-dark-border py-2 animate-fade-in`}
      >
        <MenuItem label="Discover apps" onClick={handleDiscoverApps} />
        <MenuItem label="Pricing" onClick={handlePricing} />
        <MenuItem label="Free tokens" onClick={handleFreeTokens} />
        <MenuItem label="FAQ" onClick={handleFaq} />
        <MenuItem label="Blog" onClick={handleBlog} />

        <div className="my-2 border-t border-dark-border" />

        <MenuItem label="Sign in" onClick={handleSignIn} />
      </div>
    </>,
    document.body
  );
}

function MenuItem({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`w-full px-4 py-3 text-left text-sm font-medium ${colors.text.primary} hover:bg-dark-hover transition-colors`}
    >
      {label}
    </button>
  );
}
